module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (99).519d1efd.jpg";